import { Entity } from "./entity";
import { Company } from "./company";
import { Agency } from "./agency";


export class Telematico extends Entity {    
    CompanyId: number;
    AgencyId?: number;
    Year: number;
    TaxCodeDichiarante: string;
    Content: string;
    TelematicoType: string;
    DescCompany: string;
    DescAgency: string;

    Company: Company;
    Agency?: Agency;
    // @association(PrincipalAuth)
    // principalAuth: PrincipalAuth[];
    // @association(PrincipalCertificate)
    // principalCertificate: PrincipalCertificate[];

    // constructor(data?: any) {
    //     super()
    //     this.init(data);      
    // }

    static newItem(): Agency {
        let item = new Agency();
        item.Id = 0;
        item.Disabled = null;
        return item;
    }
}

export class TelematicoSearchModel extends Entity /*implements Pagination*/ {
    TelematicoType: string | null;
    TaxCodeDichiarante?: string;
    AgencyId: number | null;
    CompanyId: number;
    Year: number | null;
}